import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ResourceModal from '@/components/resource/ResourceModal.vue'
import { ResourceChoosedType } from '@/models/types'
import { markRaw, nextTick, onBeforeUnmount, onMounted, onUnmounted, ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TinymceEditor',
  props: {
  content: String
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const editorRef = ref()
const resourceModalRef = ref()
const tinyEditor = ref()
const _content = ref('')

// eslint-disable-next-line no-undef
const emit = __emit
// eslint-disable-next-line no-undef
const props = __props

const onChoosed = (e: ResourceChoosedType) => {
  let option = {}
  if (e.field === 'file') {
    option = { text: 'file' }
  }

  if (e.field === 'image') {
    option = { alt: 'image' }
  }

  if (e.field === 'media') {
    option = { source2: 'alt.ogg', poster: '/tinymce/video.png' }
  }

  e.callback && e.callback(e.images[0], option);
}

const editor = (window as { tinyMCE?: any }).tinyMCE;
const initEditor = () => {
  editor.init({
    target: editorRef.value,
    license_key: 'gpl',
    language: 'zh-CN',
    language_url: '/tinymce/zh-CN.js',
    plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
    editimage_cors_hosts: ['picsum.photos'],
    menubar: 'file edit view insert format tools table help',
    toolbar: "undo redo | accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | anchor codesample | ltr rtl",
    autosave_ask_before_unload: true,
    autosave_interval: '30s',
    autosave_prefix: '{path}{query}-{id}-',
    autosave_restore_when_empty: false,
    autosave_retention: '2m',
    image_advtab: true,
    importcss_append: true,
    file_picker_callback: (callback, value, meta) => {
      resourceModalRef.value.onOpen(0, meta.filetype, callback)
    },
    height: 500,
    image_caption: true,
    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote',
    quickbars_insert_toolbar: false,
    noneditable_class: 'mceNonEditable',
    toolbar_mode: 'sliding',
    contextmenu: 'link image table',
    skin: 'oxide',
    content_css: 'default',
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }',
    init_instance_callback: (editor) => {
      console.log('初始化tinymce编辑器')
    }
  }).then(res => {
    tinyEditor.value = res[0]

    tinyEditor.value.on('change', (e) => {
      const content = tinyEditor.value.getContent()
      _content.value = content
      emit('change', content)
    })
  })
}

watch(
  () => props.content,
  (newVal) => {
    if (tinyEditor.value) {
      if (newVal && newVal !== _content.value) {
        _content.value = newVal
        tinyEditor.value.setContent(newVal)
      } else if (!newVal) {
        _content.value = ''
        tinyEditor.value.setContent('')
      }
    }
  }
)

onMounted(() => {
  nextTick(() => {
    initEditor()
  })
})

onBeforeUnmount(() => {
  editor.off()
  editor.remove()
  tinyEditor.value = null
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "editorRef",
      ref: editorRef,
      style: {"width":"100%","height":"500px"}
    }, null, 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(ResourceModal, {
        ref_key: "resourceModalRef",
        ref: resourceModalRef,
        onOk: onChoosed,
        zIndex: 99997
      }, null, 512)
    ]))
  ], 64))
}
}

})